export const TREE_MAP_HINT_DISMISSED_KEY = 'rulewatcher:treemap-hint-dismissed';

export const isTreeMapHintDismissed = () => {
  try {
    return sessionStorage.getItem(TREE_MAP_HINT_DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
};

export const dismissTreeMapHint = () => {
  try {
    sessionStorage.setItem(TREE_MAP_HINT_DISMISSED_KEY, 'true');
  } catch {
    // Storage can be unavailable in privacy-restricted browser contexts.
  }
};

export const resetTreeMapHint = () => {
  try {
    sessionStorage.removeItem(TREE_MAP_HINT_DISMISSED_KEY);
  } catch {
    // Storage can be unavailable in privacy-restricted browser contexts.
  }
};
